import { render } from "./NoodleView.vue?vue&type=template&id=0d907bbf"
import script from "./NoodleView.vue?vue&type=script&lang=js"
export * from "./NoodleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__